import { Box, Tooltip } from '@mui/material';
import React from 'react';

import { useTranslationContext } from '../../../shared/context';
import { AncillariesI18nKeys } from '../../../shared/types';

import {
  containerStyling,
  ratingItemStyling,
} from './AncillariesBundleRating.styling';
import { AncillariesBundleRatingProps } from './types';

// number of rating sections
const ratingSections = 3;

const ratingArray = Array.from(
  { length: ratingSections },
  (_, index) => index + 1,
);

// for AQA
const ratingClassMapping = ['none', 'low', 'medium', 'high'];

export const AncillariesBundleRating = ({
  styleParts = {},
  rating,
  ratingColors,
}: AncillariesBundleRatingProps) => {
  const { t, i18nKeys } = useTranslationContext<AncillariesI18nKeys>();

  const ratingTooltips = [
    i18nKeys.coverageNoneTooltip,
    i18nKeys.coverageLowTooltip,
    i18nKeys.coverageMediumTooltip,
    i18nKeys.coverageHighTooltip,
  ];

  return (
    <Tooltip
      slotProps={{
        tooltip: { sx: { ...styleParts.itemTooltip } },
        arrow: { sx: { ...styleParts.itemTooltipArrow } },
      }}
      className={`rating-${ratingClassMapping[rating]}`}
      data-testid="ancillaries-bundle-rating"
      title={t(ratingTooltips[rating]!)}
      aria-hidden="true"
      arrow
      enterTouchDelay={1}
    >
      <Box sx={containerStyling} onClick={(event) => event.stopPropagation()}>
        {ratingArray.map((value) => (
          <Box
            key={value}
            sx={{
              ...ratingItemStyling,
              backgroundColor:
                rating >= value ? ratingColors[rating] : ratingColors[0],
            }}
          />
        ))}
      </Box>
    </Tooltip>
  );
};
